import { InjectorService } from 'src/app/shared/services/injector/injector.service';
import { Location } from '@angular/common';

export function sanitizePathname(pathname: string, trimedHash: string): { newHash: string, newPathname: string } {
  const hashRegex = /(%[a-fA-F0-9]{2})|[ \f\n\r\t\v\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]|[,.]/g;
  const splittedPathname = pathname.split('/');
  const hashIndex = splittedPathname.findIndex((x) => decodeURIComponent(x).trim().includes(trimedHash));

  splittedPathname.splice(0, hashIndex);

  const [hash, ...rest] = splittedPathname;
  const newHash = hash.replace(hashRegex, '');
  const newPathname = [newHash, ...rest].join('/');

  return {
    newPathname: decodeURIComponent(newPathname).trim(),
    newHash
  };
}

export function sanitizeHash(hash: string): string {
  const trimedHash = hash.trim();
  const { pathname, search } = window.location;
  const { newPathname, newHash } = sanitizePathname(pathname, trimedHash);

  if (hash !== newHash) {
    const location = InjectorService.get().get(Location);
    location.go(`${newPathname}${search}`.trim());
  }

  return newHash;
}
